import { ClubsNames } from 'types/admin/tourAverages';

export const clubs: string[] = [
  'driver',
  'threeWood',
  'fiveWood',
  'hybrid',
  'threeIron',
  'fourIron',
  'fiveIron',
  'sixIron',
  'sevenIron',
  'eightIron',
  'nineIron',
  'pitchingWedge',
];

const clubsMapping: { [key: string]: ClubsNames } = {
  driver: ClubsNames.Driver,
  threeWood: ClubsNames.ThreeWood,
  fiveWood: ClubsNames.FiveWood,
  hybrid: ClubsNames.Hybrid,
  threeIron: ClubsNames.ThreeIron,
  fourIron: ClubsNames.FourIron,
  fiveIron: ClubsNames.FiveIron,
  sixIron: ClubsNames.SixIron,
  sevenIron: ClubsNames.SevenIron,
  eightIron: ClubsNames.EightIron,
  nineIron: ClubsNames.NineIron,
  pitchingWedge: ClubsNames.PitchingWedge,
};

export const clubsNamesMapper = (clubName: string) => {
  return clubsMapping[clubName] || clubName;
};
